import { useMemo } from "react";

import Badge from "ds/components/Badge";
import { BadgeVariant } from "ds/components/Badge/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentResourceOperation, IntentResourceOperationState } from "types/generated";
import { IntentProjectResourcesSuggestions } from "shared/IntentProject/useSearchIntentResourcesOperationsSuggestions/constants";

import useCellFilterAction from "../useCellFilterAction";

const getStatusBadgeState = (state: IntentResourceOperationState) => {
  switch (state) {
    case IntentResourceOperationState.PendingReview:
      return BadgeVariant.orange;
    case IntentResourceOperationState.ReadyForExecution:
      return BadgeVariant.blue;
    case IntentResourceOperationState.Finished:
      return BadgeVariant.green;
    case IntentResourceOperationState.Failed:
      return BadgeVariant.red;
    case IntentResourceOperationState.Pending:
    case IntentResourceOperationState.Unknown:
    default:
      return BadgeVariant.gray;
  }
};

const getStatusLabel = (state: IntentResourceOperationState) => {
  switch (state) {
    case IntentResourceOperationState.PendingReview:
      return "Pending Review";
    case IntentResourceOperationState.ReadyForExecution:
      return "Ready for Execution";
    case IntentResourceOperationState.Finished:
      return "Finished";
    case IntentResourceOperationState.Failed:
      return "Failed";
    case IntentResourceOperationState.Pending:
      return "Pending";
    case IntentResourceOperationState.Unknown:
    default:
      return "Unknown";
  }
};

const IntentProjectOperationsTableStateCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<IntentResourceOperation>) => {
  const filterAction = useCellFilterAction({
    filterName: IntentProjectResourcesSuggestions.STATE,
    filterValue: item.state,
  });

  const actions = useMemo(() => [filterAction], [filterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <Badge
        variant={getStatusBadgeState(item.state)}
        type="strong"
        text={getStatusLabel(item.state)}
      />
    </TableSimpleCell>
  );
};

export default IntentProjectOperationsTableStateCell;
